import { render, staticRenderFns } from "./JdsPipelineBucket.vue?vue&type=template&id=88761be2&scoped=true&"
import script from "./JdsPipelineBucket.vue?vue&type=script&lang=ts&"
export * from "./JdsPipelineBucket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88761be2",
  null
  
)

export default component.exports